import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import { Modal, Spinner } from "react-bootstrap";

const ConfirmDeleteModal = ({
  modalShow,
  setModalShow,
  type,
  handleDelete,
  message = "Yes, Delete it!",
  loading = false,
}: any) => {
  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className="fs-1 text-center">
          <FontAwesomeIcon icon={faWarning} className="text-danger" />
        </div>

        <h4 className="text-center">Are you sure?</h4>
        {type && (
          <p className="text-center mb-0">
            You won't be able to revert {type}!
          </p>
        )}
        <div className="d-flex justify-items-center gap-2 justify-content-center mt-3">
          <Button
            onClick={() => setModalShow(false)}
            className="btn btn-phoenix-danger"
          >
            No, Cancel
          </Button>
          <Button
            className="btn btn-phoenix-success"
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? <Spinner animation="border" size="sm" /> : message}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmDeleteModal;
